import { StaticTreeDataProvider } from "react-complex-tree";

import styled from "styled-components";

const treeStyleProps = ["isDraggingOver", "isSelected", "depth"];

export const TreeItemMain = styled.div.withConfig({
    shouldForwardProp: (prop) => !treeStyleProps.includes(prop),
})`
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    margin: 0;
    padding: 0 2px;
    width: 100%;
    border-radius: 2px;
    box-shadow: ${(props) => (props.isDraggingOver ? "inset 0 0 0 1px var(--color-Key)" : "none")};
    transition: background-color 140ms ease-in, box-shadow 140ms ease-in;
    background-color: ${(props) =>
        props.isDraggingOver
            ? "rgba(0, 154, 126, 0.08)"
            : props.isSelected
            ? "var(--color-ButtonHover4)"
            : "transparent"};

    &:hover {
        background-color: ${(props) =>
            props.isDraggingOver || props.isSelected
                ? props.isDraggingOver
                    ? "rgba(0, 154, 126, 0.08)"
                    : "var(--color-ButtonHover4)"
                : "rgba(0, 154, 126, 0.09)"};
    }
`;

export const TreeItemContainer = styled.li.withConfig({
    shouldForwardProp: (prop) => !treeStyleProps.includes(prop),
})`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style: none;
    padding-left: ${(props) => (props.depth < 1 ? "0px" : "24px")};
`;

export const TreeItemArrow = styled.div`
    width: 20px;
    height: 20px;

    &:hover {
        cursor: pointer;
    }
`;

export const TreeItemTitle = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    flex: 1;
    cursor: pointer;
`;

export const TreeItemKnob = styled.div`
    width: 20px;
    height: 20px;
    visibility: hidden;
    ${TreeItemMain}:hover & {
        visibility: visible;
    }
    &:hover {
        cursor: pointer;
    }
`;

export const TreeItemChildren = styled.div`
    width: 100%;
`;

const allRefsTreeData = {
    root: {
        index: "root",
        name: "root",
        children: ["all"],
    },
    all: {
        index: "all",
        name: "모든 참고문헌",
        children: [],
        isFolder: false,
    },
};

export const allRefsTreeDataProvider = new StaticTreeDataProvider(allRefsTreeData, (item, name) => ({
    ...item,
    name,
}));
